import { render } from "./CreationWorkReview.vue?vue&type=template&id=12a3fcaa&scoped=true"
import script from "./CreationWorkReview.vue?vue&type=script&lang=js"
export * from "./CreationWorkReview.vue?vue&type=script&lang=js"

import "./CreationWorkReview.vue?vue&type=style&index=0&id=12a3fcaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a3fcaa"]])

export default __exports__